import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { ADD_USER } from '../../Utils/constant';
import { store } from '../../services/service';
import { useRoleStore } from '../../store/RoleStore';
import { useStoreUser } from '../../store/user';

export const AddUser = () => {
    const {
        register,
        handleSubmit, reset,
        formState: { errors },
    } = useForm()
    const [isSubmit, setIsSubmit] = useState(false);
    const [error, setError] = useState(false);

    const [select, setSelect] = useState()
    const [typeAgent, setTypeAgent] = useState()
    const users = useStoreUser()
    const role = useRoleStore()

    const submit = (data) => {
        setIsSubmit(true)
        store(ADD_USER, 'application/json', { ...data, typeAgent: typeAgent }).then((res) => {
            reset();
            setIsSubmit(false);
            if (res.status === 200) {
                users.user({ page: 0, param: "", size: 10 })
                toast.success('Utilisateur ajouté ')
                document.getElementById('fermer-modal').click()
            }

        }).catch((err) => {
            setIsSubmit(false)
            console.log(err);
            setError(err?.response?.data?.donnee)
        })
    }

    useEffect(() => {
        reset()
    }, [reset])

    return (
        <>
            <p className='text-sm text-rose-600'>{error}</p>
            <form onSubmit={handleSubmit(submit)} className='font-mtn px-2'>
                <div className=''>
                    <div className='grid grid-cols-2 gap-1 items-center'>
                        <div className='my-2'>
                            <label htmlFor="" className='text-sm font-medium'>Nom et prenoms <span className="text-red-500">*</span></label>
                            <input type="text" placeholder="ex : Yao kofff" className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                                {...register('nomPrenoms', { required: true })} />
                            {errors.nomPrenoms && <span className="text-sm text-rose-600">Ce champs est obligatoire</span>}
                        </div>
                        <div className='my-2'>
                            <label htmlFor="" className='text-sm font-medium'>Username <span className="text-red-500">*</span></label>
                            <input type="text" placeholder="ex : @yao" className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                                {...register('username', { required: true })} />
                            {errors.username && <span className="text-sm text-rose-600">Ce champs est obligatoire</span>}
                        </div>
                        <div className='my-2'>
                            <label htmlFor="" className='text-sm font-medium'>Email <span className="text-red-500">*</span></label>
                            <input type="text" placeholder="ex : kofi@yao.ee" className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                                {...register('email', { required: true })} />
                            {errors.email && <span className="text-sm text-rose-600">Ce champs est obligatoire</span>}
                        </div>

                        <div className='my-2'>
                            <label htmlFor="" className='text-sm font-medium'>Role <span className="text-red-500">*</span></label>
                            <select {...register('role', { required: true })} onChange={(e) => setSelect(e.target.value)} className="select select-bordered w-full h-10" >
                                <option value={''} selected>Choisissez un role
                                </option>
                                {
                                    role?.data?.data?.map((item) => (
                                        <option value={item.id}>
                                            {item?.id?.replace("ROLE_", " ").toLowerCase()}
                                        </option>
                                    ))
                                }
                            </select>

                        </div>
                        {
                            select === 'ROLE_COMMERCIAL' ?
                                <div className='my-2'>
                                    <label htmlFor="" className='text-sm font-medium'>Type d'agent <span className="text-red-500">*</span></label>
                                    <select onChange={(e) => setTypeAgent(e.target.value)} className="select select-bordered w-full h-10" >
                                        <option value={''} disabled selected>
                                            Selectionnez un type
                                        </option>
                                        <option value="COMMERCIAL_DOOR_TO_DOOR">
                                            Door to Door (Porte à porte)
                                        </option>
                                        <option value="COMMERCIAL_AGENCE">En agence</option>
                                    </select>
                                </div>

                                : null
                        }

                        <div className='my-2'>
                            <label htmlFor="" className='text-sm font-medium'>Numéro de téléphone <span className="text-red-500">*</span></label>
                            <input type="text" placeholder="ex : 002587663321" className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                                {...register('numero', { required: true })} />
                            {errors.numero && <span className="text-sm text-rose-600">Ce champs est obligatoire</span>}
                        </div>

                        <div className='my-2'>
                            <label htmlFor="" className='text-sm font-medium'>Mot de passe <span className="text-red-500">*</span></label>
                            <input type="password" placeholder="" className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                                {...register('password', { required: true })} />
                            {errors.password && <span className="text-sm text-rose-600">Ce champs est obligatoire</span>}
                        </div>

                    </div>

                    <button type='submit'
                        disabled={isSubmit ? true : false}
                        className={`${!isSubmit
                            ? "text-black bg-main"
                            : "text-slate-800 bg-slate-200 "
                            } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
                    >
                        {!isSubmit ? "Ajouter un utilisateur" : "Veuillez patientez..."}{" "}
                        {isSubmit ? (
                            <span className="loading loading-dots loading-xs"></span>
                        ) : null}
                    </button>
                </div>
            </form>
        </>
    )
}
